export const getVerifyEmployeeModalVisibility = (state: any) =>
  state.player.common.verifyEmployeeModalVisible;

export const getActionName = (state: any) => state.player.common.actionName;
